import { useSubmission } from 'api/submission';
import { getManualPremiumPerilsFromSubmission } from 'helpers/utils';
import { isEmpty } from 'lodash-es';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const useManualPremiumPerils = () => {
  const { id } = useParams() as { id: string };

  const { data: submission } = useSubmission(id);

  const manualPremiumPerils = useMemo(
    () => getManualPremiumPerilsFromSubmission(submission),
    [submission?.data?.exposures?.employer],
  );

  const mainPeril = useMemo(() => {
    if (isEmpty(manualPremiumPerils)) return null;

    return manualPremiumPerils.find((peril) => peril.data.man_ismain === 'Yes');
  }, [manualPremiumPerils]);

  return { manualPremiumPerils, mainPeril };
};

export default useManualPremiumPerils;
